import React, { Component, createRef } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "react-cookies";
import { toast } from "react-toastify";
import { GET_CART_DETAIL } from "../../actions";
import Axios from "axios";
import $ from "jquery";
import { IonFooter } from "@ionic/react";
import "@ionic/react/css/core.css";
import { format } from "date-fns";
import OrderAdvancedDatetimeSlot from "./OrderAdvancedDatetimeSlot";
import closei from "../../common/images/img/close-top.svg";
import { showPriceDirect, encodeValue, showLoader, hideLoader, getReferenceID, addressFormat, getGstValue, getReverseGST } from "../Settings/SettingHelper";
import { apiUrl, CountryName, deliveryId, pickupId, uniqueID, placeholderImage } from "../Settings/Config";
/* import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
if (Capacitor.getPlatform() !== 'web') {
  Keyboard.setResizeMode({ mode: 'none' });
}
 */
class Cart extends Component {
  constructor(props) {
    super(props);
    const seletedAvilablityId = cookie.load("availability") ?? "";
    const seletedAvilablityName = cookie.load("availabilityName") ?? "";
    const orderHandledOutlet = cookie.load("orderHandledOutlet") ?? "";
    const outletName = cookie.load("outletName") ?? "";
    const deliveryUnitNumber = localStorage.getItem("deliveryUnitNumber") ?? "";
    const deliveryFloorNumber = localStorage.getItem("deliveryFloorNumber") ?? "";
    const slotType = cookie.load("slotType") ?? "";
    const orderDateTime = cookie.load("orderDateTime") ?? "";
    const displyDate = orderDateTime !== "" ? format(new Date(orderDateTime.replaceAll('"', "")), "do MMM yyyy") : "";
    const displyTime = orderDateTime !== "" ? format(new Date(orderDateTime.replaceAll('"', "")), "hh:mm a") : "";
    const path = this.props.match?.path;
    this.state = {
      path: path,
      seletedAvilablityId: seletedAvilablityId,
      orderHandledOutlet: orderHandledOutlet,
      outletName: outletName,
      deliveryUnitNumber: deliveryUnitNumber,
      deliveryFloorNumber: deliveryFloorNumber,
      deliveryUnitNumberError: "",
      trigerCart: false,
      companyEnableDeliveryFeeAuto: false,
      cartDetails: "",
      totalItem: 0,
      additionalChargeList: [],
      additionalChargeAmount: 0,
      freedeliveryCharge: 0,
      balancefreedeliveryCharge: 0,
      freeDeliveryPrecentage: 0,
      deliveryCharge: 0,
      subtotal: 0,
      taxType: "",
      taxAmount: 0,
      taxPercentage: 0,
      grandTotal: 0,
      cartstatus: "",
      globalSettings: "",
      reloadCartPage: false,

      slotType: slotType,
      orderSlotEndTime: "",
      orderSlotStrTime: "",
      firstTime: false,

      isAddressBarVisible: true,
      initialHeight: window.innerHeight,

      displyDate: displyDate,
      displyTime: displyTime,

      allowToshowCheckout: true,

      zoneDetails: "",

      outletID: cookie.load("outletID") ?? "",
      /* For Advanced Slot */
      getDateTimeFlg: "yes",
      seleted_ord_date: "",
      seleted_ord_time: "",
      seleted_ord_slot: "",
      seleted_ord_slotTxt: "",
      seleted_ord_slot_str: "",
      seleted_ord_slot_end: "",
      order_tat_time: cookie.load("orderTat") ?? "15",
      orderDateTime: "",
      orderSlotVal: "",
      orderSlotTxt: "",

      labelDateName: seletedAvilablityName??"Takeaway",
      labelTimeName: seletedAvilablityName??"Takeaway",
      isAdvanced: "no",
      deliveryTime: "",
    };
    this.wrapperRef = createRef();
  }
  componentDidMount() {
    const seletedAvilablityId = cookie.load("availability") ?? "";
    if (seletedAvilablityId === deliveryId) {
      this.loadZone();
    }

    let startTime = new Date();
    if (parseInt(this.state.slotType) === 2) {
      const orderSlotStrTime = cookie.load("orderSlotStrTime") ?? "";
      if (orderSlotStrTime !== "") {
        const orderSlotStrTime_ = orderSlotStrTime.split(":");
        startTime.setHours(orderSlotStrTime_[0]);
        startTime.setMinutes(orderSlotStrTime_[1]);
      }
      this.setState({ orderSlotStrTime: format(startTime, "hh:mm a") });
    }

    let endTime = new Date();

    if (parseInt(this.state.slotType) === 2) {
      const orderSlotEndTime = cookie.load("orderSlotEndTime") ?? "";
      if (orderSlotEndTime !== "") {
        const orderSlotEndTime_ = orderSlotEndTime.split(":");
        endTime.setHours(orderSlotEndTime_[0]);
        endTime.setMinutes(orderSlotEndTime_[1]);
      }
      this.setState({ orderSlotEndTime: format(endTime, "hh:mm a") });
    }

    this.props.getCartDetail();

    if (this.props.openCart) {
      document.addEventListener("click", this.handleClickOutside, true);
    }
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }
  componentDidUpdate(prevProps) {
    // If openCart changed
    if (!prevProps.openCart && this.props.openCart) {
      // Cart just opened
      document.addEventListener("click", this.handleClickOutside, true);
    } else if (prevProps.openCart && !this.props.openCart) {
      // Cart just closed
      document.removeEventListener("click", this.handleClickOutside, true);
    }

    var sltdOrdDate = this.state.seleted_ord_date;
    var sltdOrdTime = this.state.seleted_ord_time;
    if (sltdOrdDate !== "" && sltdOrdTime !== "") {
      this.updateOrderDateTimeCookie();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
    window.removeEventListener("resize", this.handleResize);
  }

  componentWillReceiveProps(PropsDt) {
    if (this.state.trigerCart !== PropsDt.trigerCart) {
      this.setState({ trigerCart: PropsDt.trigerCart }, function () {
        if (this.state.trigerCart === true) {
          this.props.getCartDetail();
          this.props.updateStateValue("trigerCart", false);
        }
      });
    }
    if (this.state.cartDetails !== PropsDt.cartDetails) {
      this.setState(
        { cartDetails: PropsDt.cartDetails, totalItem: PropsDt.totalItem, additionalChargeList: PropsDt.additionalChargeList, additionalChargeAmount: PropsDt.additionalChargeAmount },
        () => {
          if (PropsDt.totalItem === 0) {
            this.closeCart();
            this.setState({ firstTime: false });
          }
          this.props.updateStateValue("totalItem", PropsDt.totalItem);
          this.calculatePrice();
        }
      );
    }
    if (this.state.globalSettings !== PropsDt.settingsArr) {
      const settingsArr = PropsDt.settingsArr;
      const companyEnableDeliveryFeeAuto = settingsArr?.companyEnableDeliveryFeeAuto ?? false;
      this.setState(
        {
          globalSettings: PropsDt.settingsArr,
          companyEnableDeliveryFeeAuto: companyEnableDeliveryFeeAuto,
        },
        () => {
          this.calculatePrice();
        }
      );
    }

    if (this.state.reloadCartPage !== PropsDt.reloadCartPage) {
      this.setState({ reloadCartPage: PropsDt.reloadCartPage }, () => {
        if (PropsDt.reloadCartPage === true) {
          setTimeout(() => {
            const seletedAvilablityId = cookie.load("availability") ?? "";
            const orderHandledOutlet = cookie.load("orderHandledOutlet") ?? "";
            const outletName = cookie.load("outletName") ?? "";
            const deliveryUnitNumber = localStorage.getItem("deliveryUnitNumber") ?? "";
            const deliveryFloorNumber = localStorage.getItem("deliveryFloorNumber") ?? "";
            this.setState(
              {
                seletedAvilablityId: seletedAvilablityId,
                orderHandledOutlet: orderHandledOutlet,
                outletName: outletName,
                deliveryUnitNumber: deliveryUnitNumber,
                deliveryFloorNumber: deliveryFloorNumber,
              },
              () => {
                this.props.updateStateValue("reloadCartPage", false);
              }
            );
          }, 500);
        }
      });
    }
  }

  loadZone() {
    const zoneID = localStorage.getItem("zoneID") ?? "";
    if (zoneID !== "") {
      Axios.get(`${apiUrl}outletzone/getDetails?zoneID=${zoneID}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ zoneDetails: res.data.result }, () => {
              this.calculatePrice();
            });
          }
        })
        .catch(() => {});
    }
  }

  handleResize = () => {
    const currentHeight = window.innerHeight;
    const { initialHeight } = this.state;
    const heightDiff = initialHeight - currentHeight;

    // Heuristic: if height drops more than 100px, assume address bar is showing
    this.setState({
      isAddressBarVisible: heightDiff > 100,
    });
  };

  handleClickOutside = (event) => {
    if (this.state.firstTime === true) {
      if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target) && !event.target.closest(".react-datepicker-popper")) {
        this.closeCart();
      }
    } else {
      this.setState({ firstTime: true });
    }
  };
  calculatePrice() {
    const cartItem_ = this.state.cartDetails?.cartItem ?? [];
    const subtotal = cartItem_.reduce((sum, item) => sum + parseFloat(item.cartItemTotalPrice), 0);
    const isValid = cartItem_.length > 0 ? !cartItem_.some((item) => item.timeValidationError === "Yes") : false;
    const additionalChargeAmount = this.state.additionalChargeAmount ?? 0;

    const globalSettings = this.state.globalSettings;
    let deliveryCharge = 0;
    let freedeliveryCharge = 0;
    let balancefreedeliveryCharge = 0;
    let freeDeliveryPrecentage = 0;
    if (this.state.seletedAvilablityId === deliveryId) {
      if (this.state.companyEnableDeliveryFeeAuto === false) {
        deliveryCharge = this.state.zoneDetails?.zoneDeliveryCharge ?? 0;
        freedeliveryCharge = this.state.zoneDetails?.zoneFreeDelivery ?? 0;
        if (parseFloat(freedeliveryCharge) > 0) {
          balancefreedeliveryCharge = parseFloat(freedeliveryCharge) - parseFloat(subtotal);
          freeDeliveryPrecentage = (parseFloat(subtotal) / parseFloat(freedeliveryCharge)) * 100;
        }
        if (parseFloat(freedeliveryCharge) <= parseFloat(subtotal)) {
          deliveryCharge = 0;
        }
      }
    }
    console.log(subtotal, cartItem_, 'cartItem_cartItem_')
    let addedTotal = parseFloat(subtotal) + parseFloat(additionalChargeAmount) + parseFloat(deliveryCharge);

    const companyEnableTax = globalSettings?.companyEnableTax ?? false;
    let taxAmount = 0;
    let taxPercentage = 0;
    let taxType = "";
    if (companyEnableTax === true) {
      const companyEnableTaxPercentage = globalSettings?.companyEnableTaxPercentage ?? 0;
      taxType = globalSettings?.companyTaxType ?? "";
      if (parseFloat(companyEnableTaxPercentage) > 0) {
        taxAmount = taxType === "Inclusive" ? getReverseGST(companyEnableTaxPercentage, addedTotal) : getGstValue(companyEnableTaxPercentage, addedTotal, "format");
        taxPercentage = companyEnableTaxPercentage;
      }
    }

    let grandTotal = parseFloat(subtotal) + parseFloat(additionalChargeAmount) + parseFloat(deliveryCharge) + parseFloat(taxAmount);
    if (taxType === "Inclusive") {
      grandTotal = parseFloat(subtotal) + parseFloat(additionalChargeAmount) + parseFloat(deliveryCharge);
    }
    this.setState({
      subtotal: parseFloat(subtotal).toFixed("2"),
      taxAmount: parseFloat(taxAmount).toFixed("2"),
      taxPercentage: taxPercentage,
      deliveryCharge: parseFloat(deliveryCharge).toFixed("2"),
      freedeliveryCharge: parseFloat(freedeliveryCharge).toFixed("2"),
      balancefreedeliveryCharge: parseFloat(balancefreedeliveryCharge).toFixed("2"),
      freeDeliveryPrecentage: parseFloat(freeDeliveryPrecentage).toFixed("2"),
      taxType: taxType,
      grandTotal: parseFloat(grandTotal).toFixed("2"),
      allowToshowCheckout: isValid,
    });
  }

  closeCart(e) {
    const event = e ?? "";
    if (event !== "") {
      e.preventDefault();
    }
    this.setState({ firstTime: false });
    this.props.updateStateValue("openCart", false);
    document.querySelector("body").classList.remove("cart-sidebar-open");
  }
  incDecQty(cartItemQuantity, qtyType, index, itemID, cartItemDetails) {
    showLoader("citem-" + index);

    const cartTotalQuantity =
      this.state.cartDetails !== ""
        ? this.state.cartDetails.cartItem.filter((item) => item.cartItemProductID === cartItemDetails.cartItemProductID).reduce((sum, item) => sum + item.cartItemQuantity, 0)
        : 0;

    if (qtyType === "dec") {
      const productMinimumQuantity = cartItemDetails?.productMinimumQuantity ?? "";
      if (productMinimumQuantity !== "" && productMinimumQuantity !== null && parseInt(productMinimumQuantity) > 0) {
        if (parseInt(cartTotalQuantity) - 1 < parseInt(productMinimumQuantity)) {
          toast.error(`You must order at least ${productMinimumQuantity}`);
          return false;
        }
      }
      cartItemQuantity = parseInt(cartItemQuantity) - 1;
    } else {
      const productMaximumQuantity = cartItemDetails?.productMaximumQuantity ?? "";
      if (productMaximumQuantity !== "" && productMaximumQuantity !== null && parseInt(productMaximumQuantity) > 0) {
        if (parseInt(cartTotalQuantity) + 1 > parseInt(productMaximumQuantity)) {
          toast.error(`You can order up to ${productMaximumQuantity} items`);
          return false;
        }
      }
      cartItemQuantity = parseInt(cartItemQuantity) + 1;
    }
    const customerID = localStorage.getItem("customerID") ?? "";
    const referenceID = customerID === "" ? getReferenceID() : "";
    if(cartItemQuantity>0) {
    const postObject = {
      uniqueID: uniqueID,
      customerID: customerID,
      referenceID: referenceID,
      itemQuantity: cartItemQuantity,
    };

    Axios.put(`${apiUrl}cart/${encodeValue(itemID)}`, postObject)
      .then((res) => {
        hideLoader("citem" + index);
        if (res.data.status === "ok") {
          this.props.getCartDetail();
          toast.success(res.data.message);
        }
      })
      .catch((e) => {
        hideLoader("citem" + index);
        var errorMsg = e?.response?.data?.message || e.message;
        toast.error(errorMsg);
      });
    }else {
      Axios.delete(`${apiUrl}cart/removeItem/${encodeValue(itemID)}`)
      .then((res) => {
        if (res.data.status === "ok") {
          this.props.getCartDetail();
          toast.warning(res.data.message);
        }
      })
      .catch((e) => {
        var errorMsg = e?.response?.data?.message || e.message;
        toast.error(errorMsg);
      });
    }
  }
  removeItem(itemID, e) {
    e.preventDefault();

    Axios.delete(`${apiUrl}cart/removeItem/${encodeValue(itemID)}`)
      .then((res) => {
        if (res.data.status === "ok") {
          this.props.getCartDetail();
          toast.warning(res.data.message);
        }
      })
      .catch((e) => {
        var errorMsg = e?.response?.data?.message || e.message;
        toast.error(errorMsg);
      });
  }
  clearAll(e) {
    e.preventDefault();
    Axios.delete(`${apiUrl}cart/${encodeValue(this.state.cartDetails._id)}`)
      .then((res) => {
        if (res.data.status === "ok") {
          this.props.getCartDetail();
          toast.warning(res.data.message);
        }
      })
      .catch((e) => {
        var errorMsg = e?.response?.data?.message || e.message;
        toast.error(errorMsg);
      });
  }

  handleChange(name, e) {
    const value = e.target.value;
    this.setState({ [name]: value }, () => {
      if (name === "deliveryUnitNumber") {
        this.setState({ deliveryUnitNumberError: "" });
      }
    });
  }

  gotoCheckout(e) {
    e.preventDefault();
    if (this.state.seletedAvilablityId === deliveryId) {
      if (this.state.deliveryUnitNumber !== "") {
        localStorage.setItem("deliveryUnitNumber", this.state.deliveryUnitNumber);
        localStorage.setItem("deliveryFloorNumber", this.state.deliveryFloorNumber);
        this.props.updateStateValue("openCart", false);
        this.setState({ firstTime: false });
        document.querySelector("body").classList.remove("cart-sidebar-open");
        this.props.history.push("/checkout");
      } else {
        this.setState({ deliveryUnitNumberError: "Unit Number is required" });
      }
    } else {
      this.props.updateStateValue("openCart", false);
      document.querySelector("body").classList.remove("cart-sidebar-open");
      this.props.history.push("/checkout");
    }
  }

  /* For Advanced Slot */
  setdateTimeFlg = (field, value) => {
    if (field === "tmflg") {
      this.setState({ getDateTimeFlg: value });
    } else if (field === "ordDate") {
      var ordTime = "";
      $(".ordrdatetime_error").html("");
      this.setState({
        seleted_ord_date: value,
        seleted_ord_time: ordTime,
        seleted_ord_slot: ordTime,
        seleted_ord_slotTxt: ordTime,
        seleted_ord_slot_str: ordTime,
        seleted_ord_slot_end: ordTime,
      });
    } else if (field === "ordTime") {
      var tmSltArr = value;
      var ordTime__ = "";
      $(".ordrdatetime_error").html("");
      this.setState({
        seleted_ord_time: tmSltArr["startTime"],
        seleted_ord_slot: ordTime__,
        seleted_ord_slotTxt: ordTime__,
        seleted_ord_slot_str: ordTime__,
        seleted_ord_slot_end: ordTime__,
      });
    } else if (field === "ordSlotDate") {
      var ordTime_ = "";
      $(".ordrdatetime_error").html("");
      this.setState({
        seleted_ord_date: value,
        seleted_ord_time: ordTime_,
        seleted_ord_slot: ordTime_,
        seleted_ord_slotTxt: ordTime_,
        seleted_ord_slot_str: ordTime_,
        seleted_ord_slot_end: ordTime_,
      });
    } else if (field === "ordSlotTime") {
      var tmSltArr_ = value;
      $(".ordrdatetime_error").html("");
      this.setState({
        seleted_ord_time: tmSltArr_["startTime"],
        seleted_ord_slot: tmSltArr_["ordSlotVal"],
        seleted_ord_slotTxt: tmSltArr_["ordSlotLbl"],
        seleted_ord_slot_str: tmSltArr_["ordSlotStr"],
        seleted_ord_slot_end: tmSltArr_["ordSlotEnd"],
      });
    } else if (field === "triggerErrorPopup") {
      $.magnificPopup.open({
        items: {
          src: "#outlet-error-popup",
        },
        type: "inline",
      });
    } else if (field === "slotType") {
      this.setState({ slotType: value });
    }
  };

  /* For Advanced Slot */
  updateOrderDateTimeCookie() {
    let orderDateTime__ = cookie.load("orderDateTime") ?? "";
    orderDateTime__ = orderDateTime__ !== "" ? format(new Date(orderDateTime__.replaceAll('"', "")), "yyyy-MM-dd HH:mm") : "";
    var sltdOrdDate = this.state.seleted_ord_date;
    var sltdOrdTime = this.state.seleted_ord_time;

    var OrdDate = format(sltdOrdDate, "yyyy-MM-dd");
    var OrdHours = sltdOrdTime.getHours();
    var OrdMunts = sltdOrdTime.getMinutes();
    var OrdSecnd = sltdOrdTime.getSeconds();
    var ordDateTime = new Date(OrdDate);
    ordDateTime.setHours(OrdHours);
    ordDateTime.setMinutes(OrdMunts);
    ordDateTime.setSeconds(OrdSecnd);

    var deliveryDate = format(sltdOrdDate, "dd/MM/yyyy");
    var deliveryTime = this.pad(OrdHours) + ":" + this.pad(OrdMunts) + ":" + this.pad(OrdSecnd);

    const updatedTime = ordDateTime !== "" ? format(new Date(ordDateTime), "yyyy-MM-dd HH:mm") : "";

    cookie.save("orderDateTime", ordDateTime, { path: "/" });
    cookie.save("deliveryDate", deliveryDate, { path: "/" });
    cookie.save("deliveryTime", deliveryTime, { path: "/" });

    //var isAdvanced = this.state.isAdvanced;
    var slotType = this.state.slotType;
    var orderSlotVal = "",
      orderSlotTxt = "",
      orderSlotStrTime = "",
      orderSlotEndTime = "";
    if (slotType === "2") {
      orderSlotVal = this.state.seleted_ord_slot;
      orderSlotTxt = this.state.seleted_ord_slotTxt;
      orderSlotStrTime = this.state.seleted_ord_slot_str;
      orderSlotEndTime = this.state.seleted_ord_slot_end;
    }

    cookie.save("orderSlotVal", orderSlotVal, { path: "/" });
    cookie.save("orderSlotTxt", orderSlotTxt, { path: "/" });
    cookie.save("orderSlotStrTime", orderSlotStrTime, { path: "/" });
    cookie.save("orderSlotEndTime", orderSlotEndTime, { path: "/" });
    if (orderDateTime__ !== updatedTime) {
      setTimeout(() => {
        this.props.getCartDetail();
      }, 1000);
    }
  }
  pad(d) {
    return d < 10 ? "0" + d.toString() : d.toString();
  }
  render() {
    const cartItem = this.state.cartDetails?.cartItem ?? [];
    //const orderDateTime = cookie.load("orderDateTime") ?? "";
    return (
      <div className={`cart-sidebar ${this.props.openCart ? `open` : ""}`} ref={this.wrapperRef}>
        <div className="cart-sidebar-header">
          <div className="cart-close">
            <a href="/" onClick={this.closeCart.bind(this)}>
              <img src={closei} alt="Close" />
            </a>
          </div>
          <h3>Your Cart Details</h3>
        </div>
        <div className="cart-sidebar-parent">
          <div className="da-order-merge-column">
            <div className={`da-order-two-handling ${this.state.seletedAvilablityId === deliveryId ? "delivery-outlet" : "pickup-outlet da-order-single-handling-outlet"}`}>
              <div className={`da-order-two-handling-lhs`}>
                <h5>{this.state.seletedAvilablityId === pickupId ? "Takeaway Outlet" : "Outlet"}</h5>
                <strong>{this.state.outletName}</strong>
                <p>{this.state.orderHandledOutlet}</p>
              </div>
              <div className="da-order-two-handling-rhs">
                {this.state.seletedAvilablityId === deliveryId && (
                  <React.Fragment>
                    <h5>Delivery Location</h5>
                    <p>
                      {addressFormat(this.state.deliveryUnitNumber, this.state.deliveryFloorNumber, localStorage.getItem("deliveryAddress"), localStorage.getItem("deliveryPostalCode"), CountryName)}
                    </p>
                    <div className="single-grid">
                      <div className="form-group">
                        <input type="text" className="form-control" placeholder="Floor #" value={this.state.deliveryFloorNumber} onChange={this.handleChange.bind(this, "deliveryFloorNumber")} />
                      </div>
                    </div>
                    <div className="single-grid">
                      <div className="form-group">
                        <input type="text" className="form-control" placeholder="Unit #" value={this.state.deliveryUnitNumber} onChange={this.handleChange.bind(this, "deliveryUnitNumber")} />
                        {this.state.deliveryUnitNumberError !== "" && <span className="error">{this.state.deliveryUnitNumberError}</span>}
                      </div>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
            {this.state.path !== "/checkout" && (
              <OrderAdvancedDatetimeSlot
                {...this.props}
                hdrState={this.state}
                setdateTimeFlg={this.setdateTimeFlg.bind(this)}
                indutualText={true}
                labelDateName={`${this.state.labelDateName} Date`}
                labelTimeName={`${this.state.labelTimeName} Time`}
                outletID={this.state.outletID}
              />
            )}

            {/* <div className="da-order-date-time">
              <div className="da-order-date-time-lhs">
                <h5>{this.state.seletedAvilablityId === deliveryId ? "Delivery" : "Takeaway"} Date </h5>
                <p>{this.state.displyDate}</p>
              </div>
              <div className="da-order-date-time-rhs">
                <h5>{this.state.seletedAvilablityId === deliveryId ? "Delivery" : "Takeaway"} Time </h5>
                <p>
                  {parseInt(this.state.slotType) === 1
                    ? this.state.displyTime
                    : this.state.orderSlotStrTime !== "" &&
                      this.state.orderSlotEndTime !== "" && (
                        <>
                          {this.state.orderSlotStrTime} - {this.state.orderSlotEndTime}
                        </>
                      )}
                </p>
              </div>
            </div> */}
          </div>
          {cartItem.length > 0 && (
            <React.Fragment>
              <div className="checkout-sidebar-header">
                <span>Items</span>
                <a href="/" onClick={this.clearAll.bind(this)}>
                  Clear Items
                </a>
              </div>
              <div className="items-scroll">
                {cartItem.map((item, index) => {
                  return (
                    <div className="items-row-parent" key={index} id={`citem${index}`}>
                      <div className="items-row">
                        <div className="item-img-container">
                          <img src={item.cartItemProductImage !== "" ? item.cartItemProductImage : placeholderImage} alt={item.cartItemProductName} />
                        </div>
                        <div className="item-info-container">
                          <div className="item-info-title">
                            <h6>{item.cartItemProductName}</h6>
                            <div className="item-extrainfo-options">
                              {item.cartItemProductComboSet.length > 0 &&
                                item.cartItemProductComboSet.map((comboitem, comboindex) => {
                                  return (
                                    <React.Fragment key={comboindex}>
                                      <p>
                                        <b>{comboitem.comboName}:</b>{" "}
                                      </p>
                                      {comboitem.products.length > 0 &&
                                        comboitem.products.map((comboProItem, comboProIndex) => {
                                          return (
                                            <p key={comboProIndex}>
                                              {comboProItem.productQuantity} X {comboProItem.productName}{" "}
                                              {parseFloat(comboProItem.productPrice) > 0 ? (
                                                <>
                                                  (+$
                                                  {parseFloat(comboProItem.productPrice)})
                                                </>
                                              ) : (
                                                ""
                                              )}
                                            </p>
                                          );
                                        })}
                                    </React.Fragment>
                                  );
                                })}
                              {item.cartItemNote !== "" && (
                                <p>
                                  <strong>Note:</strong>
                                  {item.cartItemNote}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="item-quantity-box">
                            <span className="item-qty-inc" onClick={this.incDecQty.bind(this, item.cartItemQuantity, "dec", index, item._id, item)}></span>
                            <input type="text" value={item.cartItemQuantity} onChange={() => {}} className="item-count-box" />
                            <span className="item-qty-dec" onClick={this.incDecQty.bind(this, item.cartItemQuantity, "inc", index, item._id, item)}></span>
                          </div>
                        </div>
                        <div className="item-price-action">
                          <div className="item-delete-action">
                            <a href="/" onClick={this.removeItem.bind(this, item._id)}>
                              <i className="fa fa-trash-o" aria-hidden="true"></i>{" "}
                            </a>
                          </div>
                          <div className="item-price-end"> {showPriceDirect(item.cartItemTotalPrice)} </div>
                        </div>
                      </div>
                      {item.timeValidationError === "Yes" && (
                        <div className="cart-item-error">
                          This product is not available for {cookie.load("availabilityName") ?? ""} on the selected date and time. Please refer to the product description.
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </React.Fragment>
          )}
          <div className="items-footer">
            <div className="item-price-row">
              <p className="text-uppercase">SUBTOTAL</p>
              <span>{showPriceDirect(this.state.subtotal)}</span>
            </div>
            {this.state.seletedAvilablityId === deliveryId && parseFloat(this.state.deliveryCharge) > 0 && (
              <div className="item-price-row">
                <p className="text-uppercase">Delivery</p>
                <span>{showPriceDirect(this.state.deliveryCharge)} </span>
              </div>
            )}
            {this.state.additionalChargeList.length > 0 &&
              this.state.additionalChargeList.map((item, index) => {
                return (
                  <div className="item-price-row" key={index}>
                    <p className="text-uppercase">{item.title}</p>
                    <span>{showPriceDirect(item.amount)}</span>
                  </div>
                );
              })}

            {parseFloat(this.state.taxAmount) > 0 && (
              <div className="item-price-row">
                <p className="text-uppercase">
                  {this.state.taxType === "Inclusive" ? "Inclusive" : ""} GST ({this.state.taxPercentage}%)
                </p>{" "}
                <span>{showPriceDirect(this.state.taxAmount)}</span>
              </div>
            )}

            <div className="item-price-row item-grantprice-row ">
              <p className="text-uppercase">Total</p> <span>{showPriceDirect(this.state.grandTotal)}</span>
            </div>
          </div>
          {this.state.seletedAvilablityId === deliveryId && parseFloat(this.state.balancefreedeliveryCharge) > 0 && (
            <div className="progress-bar-main">
              <div className="indication">
                <div className="indication_progress">
                  <span className="hor-progress-bar" style={{ width: `${this.state.freeDeliveryPrecentage}%` }}></span>
                </div>
                <p className="help-block">{showPriceDirect(this.state.balancefreedeliveryCharge)} more to FREE delivery!</p>
              </div>
            </div>
          )}
        </div>
        {this.state.allowToshowCheckout === true && (
          <div className="fixed-footer">
            <IonFooter>
              <Link to="/checkout" className="button" onClick={this.gotoCheckout.bind(this)}>
                Proceed To Checkout
              </Link>
            </IonFooter>
          </div>
        )}
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  let cartDetails = "";
  let totalItem = 0;
  let additionalChargeList = [];
  let additionalChargeAmount = 0;
  if (Object.keys(state.cartdetails).length > 0) {
    if (state.cartdetails[0].status === "ok") {
      cartDetails = state.cartdetails[0].result;
      totalItem = state.cartdetails[0].totalItem;
      additionalChargeList = state.cartdetails[0].additionalChargeList;
      additionalChargeAmount = state.cartdetails[0].additionalChargeAmount;
    }
  }
  var globalSettings = "";
  if (Object.keys(state.settings).length > 0) {
    if (state.settings[0].status === "ok") {
      globalSettings = state.settings[0].result;
    }
  }

  return {
    cartDetails: cartDetails,
    totalItem: totalItem,
    additionalChargeList: additionalChargeList,
    additionalChargeAmount: additionalChargeAmount,
    settingsArr: globalSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCartDetail: () => {
      dispatch({ type: GET_CART_DETAIL });
    },
  };
};
export default connect(mapStateTopProps, mapDispatchToProps)(withRouter(Cart));
